module.exports = __webpack_public_path__ + "img/1554559069.8a944bc1.jpg";